import React, { Component } from "react";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import FlexView from "react-flexview";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import { initialDataPemilik } from "../../config/formConfig";
import {
  contructQueryParam,
  fetchDataAsync,
} from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import {
  ACTIVITY_TYPE,
  HttpStatus,
  Status,
} from "../../../../common/Constants";
import { mapToObjectDDL } from "../../../../common/mapper";
import ModalCustomer from "../modal/modalCustomer";
import * as R from "ramda";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
class subtabDataPersonalFJB extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
      detailCustomerVisible: false,
      provinceOptions: [],
      kotaOptions: [],
      kecamatanOptions: [],
      kelurahanOptions: [],
      zipCodeOptions: [],
      hobbyOptions: [],
      interestOptions: [],
      religionOptions: [],
      jobOptions: [],
      genderOptions: [],
      isNIKNotfound: false,
      modalFindCustomerVisible: false,
    };
  }

  componentDidMount() {
    this.fetchDDL();
  }

  fetchDDL = async () => {
    const { onTriggerLoading, setError } = this.props;
    onTriggerLoading();
    const res = await Promise.all([
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllProvince,
        setError: setError,
        menuName: "Faktur Jual Bengkel",
        args: null,
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
        setError: setError,
        menuName: "Faktur Jual Bengkel",
        args: {
          paramFilters: {
            bizparCategory: "HOBBY_TYPE",
            status: Status.ACTIVE,
          },
        },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
        setError: setError,
        menuName: "Faktur Jual Bengkel",
        args: {
          paramFilters: {
            bizparCategory: "INTEREST_TYPE",
            status: Status.ACTIVE,
          },
        },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
        setError: setError,
        menuName: "Faktur Jual Bengkel",
        args: {
          paramFilters: {
            bizparCategory: "RELIGION_TYPE",
            status: Status.ACTIVE,
          },
        },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
        setError: setError,
        menuName: "Faktur Jual Bengkel",
        args: {
          paramFilters: {
            bizparCategory: "JOB_TYPE",
            status: Status.ACTIVE,
          },
        },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
        setError: setError,
        menuName: "Faktur Jual Bengkel",
        args: {
          paramFilters: {
            bizparCategory: "GENDER_TYPE",
            status: Status.ACTIVE,
          },
        },
      }),
    ]);
    onTriggerLoading();

    res.forEach((response, idx) => {
      if (idx === 0) {
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
          this.setOptions(
            "provinceOptions",
            response.data.data.map((d) => mapToObjectDDL(d.provinceName, d.id))
          );
        }
      }

      if (idx === 1) {
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
          this.setOptions(
            "hobbyOptions",
            response.data.data.map((d) => mapToObjectDDL(d.value, d.key))
          );
        }
      }

      if (idx === 2) {
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
          this.setOptions(
            "interestOptions",
            response.data.data.map((d) => mapToObjectDDL(d.value, d.key))
          );
        }
      }

      if (idx === 3) {
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
          this.setOptions(
            "religionOptions",
            response.data.data.map((d) => mapToObjectDDL(d.value, d.key))
          );
        }
      }

      if (idx === 4) {
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
          this.setOptions(
            "jobOptions",
            response.data.data.map((d) => mapToObjectDDL(d.value, d.key))
          );
        }
      }

      if (idx === 5) {
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
          this.setOptions(
            "genderOptions",
            response.data.data.map((d) => mapToObjectDDL(d.value, d.key))
          );
        }
      }
    });
  };

  setOptions = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  getCheckBoxName = () => {
    const { subtab } = this.props;
    return subtab === "dataPemilik" ? "isCompany" : "isBuyer";
  };

  getCheckBoxLabel = () => {
    const { subtab } = this.props;

    return subtab === "dataPemilik"
      ? "PEMBELI ADALAH PERUSAHAAN / PT"
      : "DATA PEMBAWA = DENGAN DATA PEMILIK ";
  };

  getNamaPersonal = () => {
    const { subtab } = this.props;

    return subtab === "dataPemilik" ? "Nama Pemilik" : "Nama Pembawa";
  };

  getValue = (key) => {
    const { subtab, formData } = this.props;

    return formData?.[subtab]?.[key] || null;
  };

  setValue = (name, value) => {
    const { onSetSpesificData, subtab } = this.props;
    onSetSpesificData(subtab, name, value);
  };

  setObjectValue = (value) => {
    const { onSetState, subtab } = this.props;

    onSetState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [subtab]: {
          ...prev.data[subtab],
          ...value,
        },
      },
    }));
  };

  handleValueCheckBox = (name, value) => {
    const { subtab, formData, onSetState } = this.props;
    this.setState((prevState) => ({
      ...prevState,
      isChecked: value,
    }));

    if (subtab === "dataPembawa") {
      const { isCompany, ...filteredDataPemilik } = formData?.dataPemilik;
      if (value) {
        this.setObjectValue({ isBuyer: true, ...filteredDataPemilik });
      } else {
        this.setObjectValue({
          ...initialDataPemilik,
          isBuyer: false,
        });
      }
      return;
    }

    if (subtab === "dataPemilik" && value) {
      onSetState((prevState) => ({
        ...prevState,
        data: {
          ...prevState.data,
          [subtab]: {
            ...prevState.data[subtab],
            [name]: value,
            nik: null,
          },
        },
      }));
      return;
    }

    this.setValue(name, value);
  };

  handleSelectLocation = (name, value) => {
    if (name === "province") {
      this.setValue(name, value);
      this.setValue("kabkot", null);
      this.setValue("kelurahan", null);
      this.setValue("kecamatan", null);
      this.setValue("zipcode", null);

      this.setOptions("kabkotOptions", []);
      this.setOptions("kelurahanOptions", []);
      this.setOptions("kecamatanOptions", []);
      this.setOptions("zipCodeOptions", []);
      this.setOptions("zipCodeRaw", []);
      return;
    }

    if (name === "kabkot") {
      this.setValue(name, value);
      this.setValue("kelurahan", null);
      this.setValue("kecamatan", null);
      this.setValue("zipcode", null);

      this.setOptions("kelurahanOptions", []);
      this.setOptions("kecamatanOptions", []);
      this.setOptions("zipCodeOptions", []);
      this.setOptions("zipCodeRaw", []);
      return;
    }
    if (name === "kecamatan") {
      this.setValue(name, value);
      this.setValue("kelurahan", null);
      this.setValue("zipcode", null);

      this.setOptions("kelurahanOptions", []);
      this.setOptions("zipCodeOptions", []);
      this.setOptions("zipCodeRaw", []);
      return;
    }
    this.setValue(name, value);
  };

  fetchKotaOptions = async (id) => {
    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllCity,
      setError: this.props.setError,
      menuName: "Sales Order - Faktur Jual",
      args: id,
    });
    if (response.ok) {
      this.setOptions(
        "kotaOptions",
        response.data.data.map((option) =>
          mapToObjectDDL(option.kabKotName, option.kabKotId)
        )
      );
    }
  };

  fetchKecamatanOptions = async (id) => {
    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan,
      setError: this.props.setError,
      menuName: "Sales Order - Faktur Jual",
      args: id,
    });
    if (response.ok) {
      this.setOptions(
        "kecamatanOptions",
        response.data.data.map((option) =>
          mapToObjectDDL(option.kecamatanName, option.id)
        )
      );
    }
  };

  fetchKelurahanOptions = async (id) => {
    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan,
      setError: this.props.setError,
      menuName: "Sales Order - Faktur Jual",
      args: id,
    });
    if (response.ok) {
      this.setOptions(
        "kelurahanOptions",
        response.data.data.map((option) =>
          mapToObjectDDL(option.kelurahanname, option.id)
        )
      );
    }
  };

  fetchZipCodeOptions = async (id) => {
    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getKelurahanById,
      setError: this.props.setError,
      menuName: "Sales Order - Faktur Jual",
      args: id,
    });
    if (response.ok) {
      this.setOptions("zipCodeOptions", [
        mapToObjectDDL(response.data.data.zipcode, response.data.data.zipcode),
      ]);
    }
  };

  handleModalFindCustomerVisibility = () => {
    this.setState((prev) => ({
      ...prev,
      modalFindCustomerVisible: !prev.modalFindCustomerVisible,
    }));
  };

  handleCheckNIK = async () => {
    const { onTriggerLoading, setError, subtab, onSetState, onTriggerAlert } = this.props
    onTriggerLoading();
    const tab = subtab;
    onSetState((prev) => ({
      ...prev,
      errors: {
        ...prev.errors,
        [tab]: {
          ...(prev.errorMessage?.[tab] || {}),
          nik: !this.getValue("nik") ? "Field belum diisi" : null,
        },
      },
    }));

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").checkNIKSalesOrder,
      setError: setError,
      menuName: "Sales Order - Faktur Jual",
      args: contructQueryParam({ nik: this.getValue("nik") }),
    });

    if (
      res.ok &&
      res.data.status === HttpStatus.SUCCESS &&
      !R.isNil(res.data?.data)
    ) {
      const {
        namaPembeli,
        province,
        kabkot,
        kecamatan,
        kelurahan,
        gender,
        religion,
        job1,
        job2,
        hobby,
        interest,
        ...filtered
      } = res.data?.data;
      this.setState((prev) => ({
        ...prev,
        isNIKNotfound: false,
      }));
      this.props.onSetState((prevState) => ({
        ...prevState,
        data: {
          ...prevState.data,
          [tab]: {
            ...prevState.data[tab],
            ...filtered,
            name: namaPembeli || null,
            province: mapToObjectDDL(province?.provinceName, province?.id),
            kabkot: mapToObjectDDL(kabkot?.kabKotName, kabkot?.kabKotId),
            kecamatan: mapToObjectDDL(kecamatan?.kecamatanName, kecamatan?.id),
            kelurahan: mapToObjectDDL(kelurahan?.kelurahanname, kelurahan?.id),
            zipCode: mapToObjectDDL(filtered.zipCode, filtered.zipCode),
            gender: mapToObjectDDL(gender?.value, gender?.key),
            religion: mapToObjectDDL(religion?.value, religion?.key),
            job1: mapToObjectDDL(job1?.value, job1?.key),
            job2: mapToObjectDDL(job2?.value, job2?.key),
            hobby:
              hobby?.length !== 0
                ? hobby.map((item) => mapToObjectDDL(item.value, item.key))
                : null,
            interest:
              interest?.length !== 0
                ? interest.map((item) => mapToObjectDDL(item.value, item.key))
                : null,
          },
        },
      }));
    }
    if (res.data.data === null) {
      this.setState((prev) => ({
        ...prev,
        isNIKNotfound: true,
      }));
      onTriggerAlert("Informasi", "NIK tidak terdaftar pada Database")
    }
    this.props.onTriggerLoading();
  };

  getFieldRules = () => {
    const { activityType, subtab, formData, tab, isSO, isDirectSales } =
      this.props;
      
    let isMandatory = !isSO && !isDirectSales;

    let isNIKMandatory = !(
      this.getValue(this.getCheckBoxName()) || this.state.isChecked || isDirectSales
    );

    let isReadOnly =
      activityType === ACTIVITY_TYPE.VIEW ||
      activityType === ACTIVITY_TYPE.UPDATE ||
      activityType === ACTIVITY_TYPE.CORRECTION ||
      isDirectSales ||
      (isSO && tab === "NOS");

    if (subtab === "dataPembawa") {
      isNIKMandatory = !(
        this.getValue(this.getCheckBoxName()) &&
        formData?.dataPemilik?.isCompany
      );

      isMandatory = true;

      isReadOnly =
        formData?.dataPembawa?.isBuyer ||
        activityType === ACTIVITY_TYPE.VIEW ||
        (activityType === ACTIVITY_TYPE.UPDATE && !isDirectSales);
    }

    return {
      isMandatory,
      isNIKMandatory,
      isReadOnly,
    };
  };

  checkAutoFilledReadOnly = (isAutoFilled) => {
    const { subtab } = this.props
    if(subtab === "dataPemilik" || (subtab === "dataPembawa" && this.getValue("isBuyer"))){
      return isAutoFilled
    }
    return false
  }

  render() {
    const {
      provinceOptions,
      kotaOptions,
      kecamatanOptions,
      kelurahanOptions,
      zipCodeOptions,
      hobbyOptions,
      interestOptions,
      religionOptions,
      jobOptions,
      genderOptions,
      modalFindCustomerVisible,
      isNIKNotfound,
    } = this.state;
    const { errors, subtab, isSO, activityType, isDirectSales, autoFilledCustomerData } = this.props;

    const { isMandatory, isNIKMandatory, isReadOnly } = this.getFieldRules();

    const errorMessage = errors?.[subtab] || {}

    return (
      <React.Fragment>
        <div style={{ marginTop: "20px", marginBottom: "20px" }}>
          <SimpleCheckBox
            id={`input_check_box_${this.getCheckBoxName()}`}
            key={this.getCheckBoxName()}
            name={this.getCheckBoxName()}
            label={this.getCheckBoxLabel()}
            checked={
              this.getValue(this.getCheckBoxName()) || this.state.isChecked
            }
            disabled={
              activityType !== ACTIVITY_TYPE.CREATE
                ? isReadOnly || (subtab === "dataPembawa" && isSO)
                : isDirectSales
            }
            onChange={({ target }) =>
              this.handleValueCheckBox(target.name, target.checked)
            }
          />
        </div>

        <div className="grid grid-2x gap-20px grid-mobile-none">
          <div id="grid-1">
            <FlexView
              vAlignContent="center"
              style={{ justifyContent: "space-between" }}
            >
              <SimpleInput
                id="input_text_nama_pembeli"
                containerclassname="width width-full"
                readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.name)}
                name="name"
                mandatory={isMandatory}
                errorMessage={errorMessage?.nama}
                label={this.getNamaPersonal()}
                value={this.getValue("name")}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleButton
                disabled={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.name)}
                secondary={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.name)}
                styles={{ marginTop: 10, width: "auto" }}
                icon={<i className="fa fa-md fa-search" />}
                onClick={() => this.handleModalFindCustomerVisibility()}
              />
            </FlexView>

            <div>
              <FlexView
                vAlignContent="center"
                style={{ justifyContent: "space-between" }}
              >
                <SimpleInput
                  id="input_text_nik"
                  containerclassname="width width-full"
                  name="nik"
                  label="NIK"
                  errorMessage={errorMessage?.nik}
                  mandatory={isNIKMandatory}
                  box="onlyNumber"
                  readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.nik)}
                  value={this.getValue("nik")}
                  onChange={({ target }) =>
                    this.setValue(target.name, target.value)
                  }
                />
                <SimpleButton
                  styles={{ marginTop: 10, width: "auto" }}
                  text="CEK"
                  disabled={isReadOnly}
                  onClick={this.handleCheckNIK}
                  secondary={isReadOnly}
                />
              </FlexView>
            </div>

            <SimpleInput
              id="input_text_no_hp_1"
              name="hpNumber1"
              label="No HP 1"
              box="onlyNumber"
              mandatory={isMandatory}
              errorMessage={errorMessage?.noHp1}
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.hpNumber1)}
              value={this.getValue("hpNumber1")}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="input_text_no_hp_2"
              name="hpNumber2"
              label="No HP 2"
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.hpNumber2)}
              box="onlyNumber"
              value={this.getValue("hpNumber2")}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="input_text_email"
              name="email"
              label="Email"
              mandatory={isMandatory}
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.email)}
              errorMessage={errorMessage?.email}
              value={this.getValue("email")}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
            <SimpleTextArea
              id="input_text_alamat"
              name="address"
              label="Alamat"
              mandatory={isMandatory}
              errorMessage={errorMessage?.alamat}
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.address)}
              value={this.getValue("address")}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="input_text_no_kk"
              name="kkNumber"
              label="No. KK"
              box="onlyNumber"
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.kkNumber)}
              value={this.getValue("kkNumber")}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="input_text_npwp"
              name="npwp"
              label="NPWP"
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.npwp)}
              value={this.getValue("npwp")}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
            <SimpleDDL
              id="select_options_province"
              name="province"
              label="Provinsi"
              box="search"
              isClearable
              mandatory={isMandatory}
              errorMessage={errorMessage?.provinsi}
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.province)}
              options={provinceOptions}
              value={this.getValue("province")}
              onChange={(value, { name }) =>
                this.handleSelectLocation(name, value)
              }
            />
            <SimpleDDL
              id="select_options_city"
              name="kabkot"
              label="Kota"
              box="search"
              mandatory={isMandatory}
              errorMessage={errorMessage?.kota}
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.kabkot)}
              isClearable
              onMenuOpen={() => {
                this.fetchKotaOptions(this.getValue("province")?.value);
              }}
              options={kotaOptions}
              value={this.getValue("kabkot")}
              onChange={(value, { name }) =>
                this.handleSelectLocation(name, value)
              }
            />
            <SimpleDDL
              id="select_options_district"
              name="kecamatan"
              label="Kecamatan"
              box="search"
              mandatory={isMandatory}
              errorMessage={errorMessage?.kecamatan}
              isClearable
              onMenuOpen={() => {
                this.fetchKecamatanOptions(this.getValue("kabkot")?.value);
              }}
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.kecamatan)}
              options={kecamatanOptions}
              value={this.getValue("kecamatan")}
              onChange={(value, { name }) =>
                this.handleSelectLocation(name, value)
              }
            />
            <SimpleDDL
              id="select_options_subdistrict"
              name="kelurahan"
              label="Kelurahan"
              box="search"
              mandatory={isMandatory}
              isClearable
              errorMessage={errorMessage?.kelurahan}
              onMenuOpen={() => {
                this.fetchKelurahanOptions(this.getValue("kecamatan")?.value);
              }}
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.kelurahan)}
              options={kelurahanOptions}
              value={this.getValue("kelurahan")}
              onChange={(value, { name }) => {
                this.handleSelectLocation(name, value);
              }}
            />
            <SimpleDDL
              id="select_options_zipCode"
              name="zipCode"
              label="Kode Pos"
              box="search"
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.zipCode)}
              isClearable
              onMenuOpen={() =>
                this.fetchZipCodeOptions(this.getValue("kelurahan")?.value)
              }
              options={zipCodeOptions}
              value={this.getValue("zipCode")}
              onChange={(value, { name }) => this.setValue(name, value)}
            />
          </div>
          <div id="grid-2">
            <SimpleDDL
              id="select_options_jenis_kelamin"
              name="gender"
              label="Jenis Kelamin"
              box="search"
              isClearable
              mandatory={isMandatory}
              errorMessage={errorMessage?.jenisKelamin}
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.gender)}
              options={genderOptions}
              value={this.getValue("gender")}
              onChange={(value, { name }) => this.setValue(name, value)}
            />
            <SimpleDDL
              id="select_option_pekerjaan_1"
              box="search"
              name="job1"
              label="Pekerjaan 1"
              mandatory={isMandatory}
              errorMessage={errorMessage?.pekerjaan1}
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.job1)}
              options={jobOptions}
              value={this.getValue("job1")}
              onChange={(value, { name }) => this.setValue(name, value)}
            />
            <SimpleDDL
              id="select_option_pekerjaan_2"
              box="search"
              name="job2"
              label="Pekerjaan 2"
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.job2)}
              options={jobOptions}
              value={this.getValue("job2")}
              onChange={(value, { name }) => this.setValue(name, value)}
            />
            <SimpleDDL
              id="input_text_agama"
              box="search"
              name="religion"
              label="Agama"
              isClearable
              mandatory={isMandatory}
              errorMessage={errorMessage?.agama}
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.religion)}
              options={religionOptions}
              value={this.getValue("religion")}
              onChange={(value, { name }) => this.setValue(name, value)}
            />
            <div className="margin-5px">
              <div className="txt-site txt-14 txt-main txt-bold">
                <h4>Member Info</h4>
              </div>
            </div>
            <SimpleInput
              id="input_text_member_id"
              name="memberId"
              label="Member ID"
              readOnly
              value={this.getValue("memberId")}
            />
            <SimpleInput
              id="input_text_member_lvl"
              name="memberLevel"
              label="Member Lvl"
              readOnly
              value={this.getValue("memberLevel")}
            />
            <SimpleInput
              id="input_text_loyalty_lvl"
              name="loyaltyLevel"
              label="Loyalty Lvl"
              readOnly
              value={this.getValue("loyaltyLevel")}
            />

            <div className="margin-5px margin-top-30px">
              <div className="txt-site txt-16 txt-main txt-bold">
                <h4>Social Media</h4>
              </div>
            </div>
            <SimpleInput
              id="input_text_facebook"
              name="facebook"
              label="Facebook"
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.facebook)}
              value={this.getValue("facebook")}
              onChange={({ target }) => {
                this.setValue(target.name, target.value)
              }
              }
            />
            <SimpleInput
              id="input_text_instagram"
              name="instagram"
              label="Instagram"
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.instagram)}
              value={this.getValue("instagram")}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="input_text_linkedIn"
              name="linkedin"
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.linkedin)}
              label="LinkedIn"
              value={this.getValue("linkedin")}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="input_text_twitter"
              name="x"
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.x)}
              label="X (Twitter)"
              value={this.getValue("x")}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="input_text_tiktok"
              name="tiktok"
              label="Tiktok"
              readOnly={isReadOnly || this.checkAutoFilledReadOnly(autoFilledCustomerData?.tiktok)}
              value={this.getValue("tiktok")}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
            <SimpleDDL
              id="select_options_hobby"
              name="hobby"
              label="Hobby"
              box="search"
              isClearable
              readOnly={isReadOnly}
              options={hobbyOptions}
              value={this.getValue("hobby")}
              onChange={(value, { name }) => this.setValue(name, value)}
            />
            <SimpleDDL
              id="select_options_interest"
              name="interest"
              label="Interest"
              box="search"
              isClearable
              readOnly={isReadOnly}
              options={interestOptions}
              value={this.getValue("interest")}
              onChange={(value, { name }) => this.setValue(name, value)}
            />
          </div>
        </div>
        {modalFindCustomerVisible && (
          <ModalCustomer
            {...this.props}
            visible={modalFindCustomerVisible}
            onClickClose={this.handleModalFindCustomerVisibility}
            setValue={this.setValue}
          />
        )}
      </React.Fragment>
    );
  }
}

export default subtabDataPersonalFJB;
